export default {
  statistics: {
    total_campaigns: 'Total campanii',
    todays_sent_messages: 'Mesaje trimise azi',
    total_subscribers: 'Abonați',
    average_click_rate: 'Rată medie de accesare',
  },
};
